import { toast } from 'react-toastify';

const DEFAULT_OPTIONS = {
  position: toast.POSITION.TOP_RIGHT,
  className: 'toast__wrapper',
  bodyClassName: 'toast__body',
  progressClassName: 'toast__progress',
};

export const alertSuccess = (message: string, opts = DEFAULT_OPTIONS) => {
  toast.success(message, {
    ...opts,
    className: `${opts.className} success`,
  });
};

export const alertError = (message: string, opts = DEFAULT_OPTIONS) => {
  toast.error(message, {
    ...opts,
    className: `${opts.className} error`,
  });
};

export const alertWarn = (message: string, opts = DEFAULT_OPTIONS) => {
  toast.warn(message, opts);
};

export const alertInfo = (message: string, opts = DEFAULT_OPTIONS) => {
  toast.info(message, opts);
};

export const alert = (message: string, opts: any) => {
  toast(message, opts);
};
